import { FunctionComponent, useEffect } from "react";
import { DailyRefresher } from "./daily-refresher-service.ts";

export const DailyRefresherMount: FunctionComponent = () => {
  useEffect(() => {
    const refresher = DailyRefresher.getInstance();
    refresher.start();
    return () => refresher.stop();
  }, []);

  return null;
};
